var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgForward = function SvgForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.752 21a.743.743 0 01-.528-.22.782.782 0 01-.008-1.088L14.622 12 7.216 4.308a.781.781 0 01.008-1.087.74.74 0 011.063.008l7.926 8.232a.782.782 0 010 1.078L8.287 20.77a.741.741 0 01-.535.23"
  })));
};

export default SvgForward;